import { useMessagesRepository } from '@Hooks/useRepository';
import { NotificationsRepository } from '@Repositories/Messages';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useAcknowledgeNotification() {
    const notifications = useMessagesRepository(NotificationsRepository);
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (id: string) => notifications.acknowledge(id),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['notifications'] }),
    });
}
